const formatRowErrors = (label, errors = []) => {
  if (!errors.length) return [];

  const lines = [`${label}:`];
  errors.slice(0, 8).forEach((error) => {
    const rowLabel =
      error.row != null ? `Row ${error.row}` : error.code ? `Code ${error.code}` : "Row";
    lines.push(`- ${rowLabel}: ${error.message}`);
  });

  if (errors.length > 8) {
    lines.push(`- ...and ${errors.length - 8} more`);
  }

  return lines;
};

export const formatImportSummary = (data) => {
  if (!data) return "Import failed";
  if (typeof data === "string") return data;

  const lines = [];
  if (data.message) lines.push(data.message);
  lines.push(...formatRowErrors("Parse errors", data.parseErrors));
  lines.push(...formatRowErrors("Save errors", data.saveErrors));
  lines.push(...formatRowErrors("Lookup warnings", data.lookupWarnings));

  if (data.skippedNoCode > 0 && !data.message?.includes("without Code")) {
    lines.push(`Skipped ${data.skippedNoCode} row(s) without Code.`);
  }

  return lines.filter(Boolean).join("\n");
};

export const getImportErrorMessage = (error) => {
  if (error == null) return "Import failed";
  if (typeof error === "string") return error;
  return formatImportSummary(error);
};

export const hasImportWarnings = (data) =>
  typeof data === "object" &&
  data != null &&
  ((data.parseErrors?.length ?? 0) > 0 ||
    (data.saveErrors?.length ?? 0) > 0 ||
    (data.lookupWarnings?.length ?? 0) > 0 ||
    (data.skippedNoCode ?? 0) > 0);
